import { ContentBlock } from "@/components/PageInset";
import { Button } from "@/components/ui/Button";
import { ButtonLink } from "@/components/ui/Link";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { GivenwellDeadBirdIcon } from "@/icons/givenwell";
import { getErrorMessage } from "@/utils/error";
import { Heading, Text } from "@givenwell/components";
import { colors } from "@givenwell/theme";
import { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect, useEffectEvent, useState } from "react";

function reload() {
  // eslint-disable-next-line no-self-assign
  location.pathname = location.pathname;
}

export function ErrorComponent({ error }: ErrorComponentProps) {
  const [offline] = useState(!navigator.onLine);

  const recordError = useEffectEvent(() => {
    import("@/utils/analytics").then(({ captureException }) => {
      captureException(error);
    });
  });

  useEffect(() => {
    if (!offline) {
      recordError();
    }
  }, [error, offline]);

  if (offline) {
    return <OfflinePage />;
  }

  return (
    <PageWrapper>
      <ContentBlock css={{ width: "100%", maxWidth: 600, mx: "auto" }}>
        <GivenwellDeadBirdIcon css={{ mb: 16, color: colors.text2 }} />
        <Heading as="h1" css={{ mb: 16, fontScale: "2xl" }}>
          This page isn't working
        </Heading>

        <Text css={{ mb: 16 }}>
          <b>Error:</b> {getErrorMessage(error)}
        </Text>

        <Text css={{ mb: 32 }}>Please try again later.</Text>

        <Button css={{ mb: 16 }} variant="filled" color="primary" onClick={reload}>
          Reload
        </Button>
        <ButtonLink variant="outlined" color="primary" to="/">
          Go Home
        </ButtonLink>
      </ContentBlock>
    </PageWrapper>
  );
}

function OfflinePage() {
  return (
    <PageWrapper>
      <ContentBlock css={{ width: "100%", maxWidth: 600, mx: "auto" }}>
        <GivenwellDeadBirdIcon css={{ mb: 16, color: colors.text2 }} />
        <Heading as="h1" css={{ mb: 16, fontScale: "2xl" }}>
          Connect to the internet
        </Heading>

        <Text css={{ mb: 32 }}>You're offline. Check your connection.</Text>

        <Button variant="filled" color="primary" onClick={reload}>
          Reload
        </Button>
      </ContentBlock>
    </PageWrapper>
  );
}
